const React = require('react');
const { connect } = require('react-redux');
const { context } = require('app-context');
const FallbackSpinner = require('../../helpers/fallback-spinner');
const withPropTypeDependencies = require('utils/withPropTypeDependencies');
const { dependencyPropTypes, getDashboardFilterRoles } = require('../dashboard-dependencies');

const {
    Suspense,
    lazy
} = React;

const LazyAdminDashboard = lazy(() => import(/* webpackChunkName: "route-app-admin-dashboard-view" */ '../components/AdminDashboard')
    .then((module) => ({
        default: module.default || module
    })));

const AdminDashboardView = (props) => (
    <Suspense fallback={<FallbackSpinner />}>
        <LazyAdminDashboard {...props} />
    </Suspense>
);

const selectors = context.selectors.all;
const actions = context.actions;

const AdminDashboardContainer = connect(
    (state) => {

        const user = selectors.getCurrentUser(state).user();
        const schools = selectors.getSchools(state);

        return {
            schools: schools.map((school) => ({ id: school.id, name: school.name })),
            schoolFilterRolesById: schools.reduce((acc, school) => {

                acc[school.id] = getDashboardFilterRoles(
                    selectors.getSchoolRoles_byId(state, school.id) || []
                );
                return acc;
            }, {}),
            userStats: selectors.getUserStats(state),
            messagesStats: selectors.getMessagesStats(state),
            currentUser: user ? { email: user.email, schoolId: user.schoolId } : null
        };
    },
    (dispatch) => ({
        fetchUserStats: (filters) => {

            return dispatch(actions.dashboard.getUserStats(filters));
        },
        fetchMessagesStats: (filters) => dispatch(actions.dashboard.getMessagesStats(filters)),
        fetchCustomInterests: (schoolId) => dispatch(actions.dataFetching.fetchCustomInterests({ schoolId }))
    })
)(withPropTypeDependencies(AdminDashboardView, {
    propTypes: dependencyPropTypes,
    timeoutMs: 30000
}));

AdminDashboardContainer.dependencyPropTypes = dependencyPropTypes;

module.exports = AdminDashboardContainer;
